/* bv-fit-title.js — "Fit title to full width" on the PDP Title block.
   Measures the title at a reference size and scales font-size so the text spans the
   full width of its column on one line, clamped to data-fit-min / data-fit-max.
   If even the minimum size does not fit, it drops to the minimum and lets the text wrap.
   Re-runs on resize, after web fonts load, and when the theme editor re-renders the section. */
(function () {
  'use strict';
  if (window.__bvFitTitle) return;
  window.__bvFitTitle = true;

  var REF = 100; /* px: measurement size */

  function fit(el) {
    var min = parseFloat(el.dataset.fitMin) || 24;
    var max = parseFloat(el.dataset.fitMax) || 120;
    var width = el.clientWidth;
    if (!width) return;

    /* measure the text at the reference size with the element's real font */
    var probe = el.__bvProbe;
    if (!probe) {
      probe = document.createElement('span');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;left:-99999px;top:0;visibility:hidden;white-space:nowrap;pointer-events:none;';
      document.body.appendChild(probe);
      el.__bvProbe = probe;
    }
    var cs = getComputedStyle(el);
    probe.style.fontFamily = cs.fontFamily;
    probe.style.fontWeight = cs.fontWeight;
    probe.style.fontStyle = cs.fontStyle;
    probe.style.letterSpacing = cs.letterSpacing;
    probe.style.textTransform = cs.textTransform;
    probe.style.fontSize = REF + 'px';
    probe.textContent = el.textContent;

    var textW = probe.getBoundingClientRect().width || 1;
    var size = REF * width / textW;
    /* letter-spacing in em scales with font-size, so the ratio holds; trim a hair so the
       last glyph never spills past the column */
    size = size * 0.995;

    if (size < min) {
      el.classList.add('is-wrapping');
      size = min;
    } else {
      el.classList.remove('is-wrapping');
      if (size > max) size = max;
    }
    el.style.setProperty('font-size', size.toFixed(2) + 'px', 'important');
  }

  function fitAll() {
    document.querySelectorAll('[data-fit-title]').forEach(fit);
  }

  var ro = ('ResizeObserver' in window) ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { fit(e.target); });
  }) : null;

  function init() {
    document.querySelectorAll('[data-fit-title]').forEach(function (el) {
      if (el.__bvFitBound) return;
      el.__bvFitBound = true;
      fit(el);
      if (ro) ro.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  window.addEventListener('load', fitAll);
  if (!ro) window.addEventListener('resize', fitAll);
  /* theme editor: section re-renders replace the h1 */
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
